import { Tool } from './Tool'
import { Draw, Snap } from 'ol/interaction'
import GeometryType from 'ol/geom/GeometryType'
import VectorSource from 'ol/source/Vector'
import Geometry from 'ol/geom/Geometry'

export default class PolygonTool extends Tool {
    private drawInteraction!: Draw;
    private snapInteraction!: Snap;

    public removeInteractions(): void {
        if (this.drawInteraction) { this.state.map?.removeInteraction(this.drawInteraction) }
        if (this.snapInteraction) { this.state.map?.removeInteraction(this.snapInteraction) }
    }

    public addInteractions(): void {
        this.drawInteraction = new Draw({
            source: this.state.vectorSource as VectorSource<Geometry>,
            type: GeometryType.POLYGON,
            condition: this.manageClickEvent
        })

        this.state.map?.addInteraction(this.drawInteraction)

        this.drawInteraction.on('drawend', async (evt) => {
            await this.annotationManager.applyAnnotationDetails(evt.feature, this.state.userConfiguration.showAnnotationWindow)
        })

        this.snapInteraction = new Snap({
            source: this.state.vectorSource as VectorSource<Geometry>
        })

        this.state.map?.addInteraction(this.snapInteraction)
    }
}
